import {MerchantBalanceAccountApiBase} from "@/api/paymentApi";

class MerchantBalanceAccountApiBaseApi extends MerchantBalanceAccountApiBase {

}

export default new MerchantBalanceAccountApiBaseApi();